// @flow
import { PrivateStateAccessor, type Action as AllActions } from '@ta/common.state';
import type { ContentType, ContentTypePairKey } from './types';

/** A secondary store to track suppressed content client-side.
 * We don't support client schemas, so direct apollo cache manipulation is difficult. */

export type SuppressedContentState = {|
  suppressedContent: ContentTypePairKey[],
|};

type ReduxState = any;

// Type def for the actions of our slice
type RemoveContentActions = {|
  suppressContent: (contentType: ContentType, id: string) => void,
|};

const DEFAULT_STATE: SuppressedContentState = {
  suppressedContent: [],
};

const KEY = 'suppressed-content-state';

export const STATE_ACCESS: PrivateStateAccessor<SuppressedContentState> = new PrivateStateAccessor(
  KEY,
  DEFAULT_STATE,
);

// Export the method that fetches the state.
export const getState = (state: ReduxState) => STATE_ACCESS.getFrom(state);

const SUPPRESS_CONTENT = 'SUPPRESS_CONTENT';

export const ACTIONS: RemoveContentActions = {
  suppressContent: (contentType: ContentType, id: string) =>
    STATE_ACCESS.action({
      type: SUPPRESS_CONTENT,
      contentType,
      id,
    }),
};

// Set the reducer for the private slice.
STATE_ACCESS.setReducer((prevState: SuppressedContentState, action: AllActions) => {
  switch (action.type) {
    case SUPPRESS_CONTENT:
      return {
        suppressedContent: [...prevState.suppressedContent, [action.contentType, action.id]],
      };
    default:
      return prevState;
  }
});
